import type { VariablesOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';
import { useSnackbar } from '@/features/snackbar';
import { makeGqlMutation } from '@/utilities/gqlQuery';

const MUTATION = gql(
  `
  mutation CreateNarrative(
    $input: CreateNarrativeInput!
    $setPrimary: Boolean!
  ) {
    createNarrative(input: $input, setPrimary: $setPrimary) {
      id
      valuation {
        type
      }
    }
  }
`
);

type Variables = VariablesOf<typeof MUTATION>;

const useCreatePublicNarrativeBase = makeGqlMutation(MUTATION);

export const useCreatePublicNarrative = ({
  onSuccess,
}: {
  onSuccess: (narrativeId: string) => void;
}) => {
  const { addSnackbar } = useSnackbar();

  return useCreatePublicNarrativeBase({
    onSuccess: async (narrativeResponse) => {
      onSuccess(narrativeResponse.createNarrative.id);
      addSnackbar({
        type: 'positive',
        lifeTime: 1000,
        message: 'Successfully created narrative',
      });
    },
    onError: () => {
      addSnackbar({
        type: 'negative',
        lifeTime: 2000,
        message: 'Failed to create narrative',
      });
    },
  });
};

export type CreateNarrativeInput = Variables['input'];
export type CreateValuationInput = CreateNarrativeInput['valuations'][number];
export type CreateContentBlockInput =
  CreateNarrativeInput['contentBlocks'][number];
